import React,{ forwardRef } from 'react';
import { Box, Typography } from '@mui/material';
import { BaseBlockProps } from '../types';
import { useSumFieldData } from '../../../hooks';
import {
    BlockWrapper,
    BlockHeader,
    BlockToolbar,
    LoadingState,
} from '../base';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SumFieldsBlockProps extends BaseBlockProps {}

export const SumFieldsBlock = forwardRef<HTMLDivElement, SumFieldsBlockProps>(
    (
        {
            kedo,
            block,
            dashboard,
            onClose,
            onMax,
            onSuccess,
            getBlockHeader,
            dossier,
            link,
        },
        ref
    ) => {
        const { data, loading, refetch } = useSumFieldData({
            kedo,
            block,
            dossier,
            link,
        });

        return (
            <BlockWrapper
                ref={ref}
                dashboard={dashboard}
                height="100%"
                sx={{
                    marginBottom: '30px',
                    minHeight: '300px',
                    minWidth: '300px',
                }}
            >
                <BlockHeader>
                    <BlockToolbar
                        kedo={kedo}
                        block={block}
                        onClose={onClose}
                        onMax={onMax}
                        onSuccess={onSuccess}
                        fetchData={refetch}
                    />
                    {getBlockHeader?.(block, dossier)}
                </BlockHeader>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                    }}
                >
                    {loading ? (
                        <LoadingState />
                    ) : (
                        <Typography variant="h1" component="div" align="center">
                            {data ?? '—'}
                        </Typography>
                    )}
                </Box>
            </BlockWrapper>
        );
    }
);

SumFieldsBlock.displayName = 'SumFieldsBlock';
